import { render, staticRenderFns } from "./ActionSendMailable.vue?vue&type=template&id=99e5c00a&scoped=true&"
import script from "./ActionSendMailable.vue?vue&type=script&lang=js&"
export * from "./ActionSendMailable.vue?vue&type=script&lang=js&"
import style0 from "./ActionSendMailable.vue?vue&type=style&index=0&id=99e5c00a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e5c00a",
  null
  
)

export default component.exports